import { FC } from 'react';
import styles from './QuoteCard.module.scss';
import { IQuotesData } from '@/interfaces/quotes.interface';

interface IQuoteCard {
  quote: IQuotesData;
}

const QuoteCard: FC<IQuoteCard> = ({ quote }) => {
  return (
    <div key={quote.id} className={styles.quoteCard}>
      <p className={styles.quoteCard__txt}>{quote.text}</p>
      <div className={styles.quoteCard__controls}>
        <div className={styles.quoteCard__controlsWrap}>
          <div className={`${styles.quoteCard__btn} ${styles.quoteCard__btn_like}`}></div>
          <span className={styles.quoteCard__likesCounter}> </span>
          <div className={`${styles.quoteCard__btn} ${styles.quoteCard__btn_dislike}`}></div>
          <span className={styles.quoteCard__user}>{quote.user_name}</span>
        </div>
        <div className={styles.quoteCard__share}>Поделиться цитатой</div>
      </div>
    </div>
  );
};

export default QuoteCard;
